var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:{ visible: _vm.visible },attrs:{"id":"btnScrollToTop","variant":"primary"},on:{"click":_vm.scrollToTop}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":['fas','arrow-up']}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }